import { createFileRoute } from '@tanstack/react-router';
import { listSearchSchema } from '@/lib/list-search-schema';
import OfficeActions from '@/pages/OfficeActions';

export const Route = createFileRoute('/_authenticated/office-actions')({
  validateSearch: listSearchSchema,
  component: OfficeActions,
});
